module.exports = __webpack_public_path__ + "img/background.52ae4f6a.png";